import { periodForUnixSeconds } from "../save/defaults";
import type { OrbitForgeSave } from "../save/types";

export function advanceRuntimePeriodStats(save: OrbitForgeSave, deltaSeconds: number, nowUnixSeconds: number): OrbitForgeSave {
  const period = periodForUnixSeconds(nowUnixSeconds);
  const nextSave = period.dayId !== save.periods.dayId || period.weekId !== save.periods.weekId ? { ...save, periods: period } : save;

  nextSave.stats.TotalPlayTimeSeconds += deltaSeconds;
  nextSave.stats.DailyPlayTimeSeconds += deltaSeconds;
  nextSave.stats.WeeklyPlayTimeSeconds += deltaSeconds;
  return nextSave;
}
